var _this = this;
import * as tslib_1 from "tslib";
import { orchestrator } from 'satcheljs';
import { turnOffFocusedInbox } from 'owa-fms-action-providers';
import { lazySetFocusedInboxOnOff } from 'owa-mail-focused-inbox-config';
export default orchestrator(turnOffFocusedInbox, function (message) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        lazySetFocusedInboxOnOff.importAndExecute(false, false);
        return [2 /*return*/];
    });
}); });
//# sourceMappingURL=turnOffFocusedInbox.js.map